import { render, staticRenderFns } from "./choose-template.vue?vue&type=template&id=6519292d&scoped=true&"
import script from "./choose-template.vue?vue&type=script&lang=js&"
export * from "./choose-template.vue?vue&type=script&lang=js&"
import style0 from "./choose-template.vue?vue&type=style&index=0&id=6519292d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6519292d",
  null
  
)

export default component.exports